




























































































































import { JobDetailsModule } from "@/store/modules/jobDetails";
import { Component, Vue } from "vue-property-decorator";
import GiganautVue from "@/components/Shared/GiganautVue";
import { VuetifyConfirmObject } from "vuetify-confirm";
import JobRequirementsEdit from '@/components/Jobs/JobRequirementsEdit.vue';
import JobSummaryEdit from '@/components/Jobs/JobSummaryEdit.vue';
import JobDescriptionEdit from '@/components/Jobs/JobDescriptionEdit.vue';

@Component({
  name: "JobRequirements",
  components: { JobRequirementsEdit, JobSummaryEdit, JobDescriptionEdit },
})
export default class extends GiganautVue {
  
  get job() {
    return JobDetailsModule.currentJob;
  }
}
